import type { ComponentProps } from 'lib/component-props';
import { TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { PrescriptionDrugTables } from '../PlanDetails/PlanDetails.Types';

export type PlanDetails = {
  id: string;
  planName: TextField;
  contract: TextField;
  pbp: TextField;
  groupId: TextField;
  cavulusPlanName: TextField;
  planDetailEntries: PlanDetailEntries;
  prescriptionDrugTables: PrescriptionDrugTables;
};

export type PlanDetailEntries = {
  targetItems: PlanDetailEntry[];
};

export type PlanDetailEntry = {
  description: TextField;
  entryRow: PlanDetailRowParent;
};

export type PlanDetailRowParent = {
  id: string;
  label: TextField;
  entryTable: PlanDetailGroupParent;
};

export type PlanDetailGroupParent = {
  id: string;
  caption: TextField;
};

export type PlanDetailGroup = {
  id: string;
  caption: string;
  planDetailRows: Array<PlanDetailRow>;
};

export type PlanDetailRow = {
  id: string;
  label: string;
  tooltip: string;
  planEntries: Array<PlanEntry>;
};

export type PlanEntry = {
  id: string;
  name: string;
  value: string;
};

export type PlanTypes = {
  id: string;
  name: string;
  fields: PlanTypeFields;
};

export type PlanTypeFields = {
  id: string;
  planDetailPage: {
    url?: string;
  };
  planSearchPage: {
    url: string;
  };
};

export type DrugCoverageTableGroups = {
  id: string;
  tableGroupName: string;
  groupCaption: string;
  planComparisonTableHeader: string;
  drugCoverageTables: Array<RxCoverageTable>;
};

export type RxCoverageTable = {
  coverageTablename: string;
  coulmnGroup: ColumnGroup;
  rows: Array<RxRow>;
};

export type ColumnGroup = {
  columns: Array<RxColumn>;
};

export type RxColumn = {
  name: string;
  columnColor: string;
};

export type RxRow = {
  tooltip: string;
  cells: Array<RxCell>;
};

export type RxCell = {
  isHeader: boolean;
  label: string;
};

export type YearItem = {
  id: string;
  year: string;
  enrollButtonStart: Date;
};

export type PlanComparisonTableFields = {
  planType: PlanTypes;
  planDetailGroupLayout: Array<PlanDetailGroup>;
  rowNotCoveredText: TextField;
  rxTableNotCoveredText: TextField;
  rxRowNotCoveredText: TextField;
  showRxDrugCoverageTable: {
    value: boolean;
  };
  drugCoverageGroups: Array<DrugCoverageTableGroups>;
  planYears: YearItem[];
};

export type PlanComparisonTableProps = ComponentProps & {
  fields: PlanComparisonTableFields;
};
